/**
 * Clasificación de entradas del inventario de software.
 *
 * Windows apunta las actualizaciones en el mismo registro `Uninstall` que el
 * software normal, así que se colaban en la pestaña Software mezcladas con las
 * aplicaciones: un equipo con 40 parches parecía tener 40 programas.
 *
 * La lista de la pestaña **Actualizaciones** sale de `windows_updates`
 * (`Microsoft.Update.Session` / `Win32_QuickFixEngineering`), que es la fuente
 * buena. Estas entradas solo se ocultan de Software; no se borran del blob.
 */

const PREFIJOS_ACTUALIZACION = [
  'update for ',
  'security update for ',
  'hotfix for ',
  'actualización para ',
  'actualización de seguridad para ',
  'actualizacion para ',
  'actualizacion de seguridad para ',
  'revisión para ',
  'revision para ',
];

const PATRONES_ACTUALIZACION = [
  /^kb\d{5,}/i,
  /^windows malicious software removal tool/i,
  /^herramienta de eliminación de software malintencionado/i,
  // Los controladores que llegan por Windows Update se registran como
  // «Paquete de controladores de Windows - <fabricante> <modelo> (fecha)».
  // Son actualizaciones, no aplicaciones: su sitio es la pestaña
  // Actualizaciones. Ojo con no filtrar «…Windows Driver» de un instalador
  // normal (Realtek, por ejemplo): esos llevan el prefijo del fabricante y se
  // quedan como software.
  /^paquete de controladores de windows\b/i,
  /^windows driver package\b/i,
  // Base de datos que Windows Update deja como «programa» y no es una app.
  /^microsoft windows application compatibility fix database/i,
];

/**
 * `true` si la entrada del registro es una actualización de Windows.
 *
 * Solo se mira el nombre: el `publisher` es «Microsoft Corporation» también
 * para Office y Visual Studio, y excluir por ahí escondería software real.
 */
export function isWindowsUpdateEntry(entry) {
  const nombre = String(
    typeof entry === 'string' ? entry : entry?.name || entry?.display_name || '',
  )
    .trim()
    .toLowerCase();
  if (!nombre) return false;
  if (PREFIJOS_ACTUALIZACION.some((prefijo) => nombre.startsWith(prefijo))) return true;
  return PATRONES_ACTUALIZACION.some((patron) => patron.test(nombre));
}

/** Entradas que sí son software de verdad (sin actualizaciones). */
export function filterSoftwareEntries(entries) {
  if (!Array.isArray(entries)) return [];
  return entries.filter((entry) => !isWindowsUpdateEntry(entry));
}
